import React from "react"
import { Link } from "react-router-dom"
import ScrollParentToTop from "../components/ScrollParentToTop"

const Contact: React.FC = () => {
	return (
		<div>
			<ScrollParentToTop />
			<div className="bg-blue">
						<div className="max-w-[1324px] mx-auto">
							<h1 className="bg-blue text-white py-24 px-6 md:px-0">Kontakt</h1>
						</div>
					</div>
					<div className="mx-auto max-w-[90%] md:max-w-[1324px]  text-left">
						{/*<h2 className="mb-4 text-center text-blue">Kontakt</h2>*/}
						<p className="mt-12">
							Solltest du Fragen zur Geld-Zurück-Aktion haben, dann wende Dich gerne per E-Mail an <a href="mailto:info@trekbars-geld-zurueck.de" className="underline font-bold">info@trekbars-geld-zurueck.de</a>
						</p>
					</div>
					<div className=" py-10 pt-5 text-center text-xl text-blue">
						<Link
							to="/"
							className="btn-primary-yellow"
						>
							Zurück
						</Link>
					</div>
						<div className=" bg-blue">
							<div className="max-w-[1324px] mx-auto px-6 pt-4 md:px-0 md:pt-12 pb-12">
								<div className="flex flex-wrap justify-evenly gap-4  max-w-[80%] md:max-w-[60%] mx-auto mt-6 md:mt-0">
									<Link to="/faq" rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									FAQ
									</Link>
									<Link to="/teilnahmebedingungen" rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									Teilnahmebedingungen
									</Link>
									<a href="https://www.trekbars.com/de/datenschutzbestimmungen" target="_blank" rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									Datenschutz
									</a>
									<Link to="/kontakt"  rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									Kontakt
									</Link>
									<Link to="/impressum"  rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									Impressum
									</Link>
									</div>
							</div>
						</div>
			</div>
	)
}
export default Contact
